/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import { Notify } from 'vant';
import router from '../router/index'
const DEFAULT_ERR_MSG = '呀，付款的人太多了。没挤进去。请重新扫码付款吧~';



// 1. 定义默认baseURL + 自定义baseURL（建议从环境变量读取，也可直接写死）
const DEFAULT_BASE_URL = process.env.VUE_APP_BASE_API;
// 自定义的另一个baseURL（比如从环境变量取，或直接写具体地址）
const AGENT_BASE_URL = process.env.VUE_APP_AGENT_API; //代理商

console.log("DEFAULT_BASE_URL",process.env.VUE_APP_AGENT_API)

// 环境的切换
axios.defaults.baseURL = DEFAULT_BASE_URL;

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';


// 请求拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    })
// 响应拦截器
axios.interceptors.response.use(
    response => {
        // console.log("response",response)
        const status = response.data.code;
        //200通过 401没有授权 403禁止访问 404没有发现
        if(status === 200){
            return Promise.resolve(response);
        }else if(status === 401||status === 403){   
            Notify({ type: 'primary', message:  response.data.msg});
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            router.replace({
                path: '/login'
            });
        }else{
            Notify({ type: 'primary', message:  response.data.msg});
            return Promise.resolve(response);
        }
    },
    // 服务器状态码不是200的情况    
    error => {
      console.log("error",error); // for debug
      Notify({ 
        message:  error.message||DEFAULT_ERR_MSG
      });
      return Promise.reject(error)
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params, options = {}) {
     const baseURL = options.customBaseURL || DEFAULT_BASE_URL;
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params,
                baseURL
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params, options = {}) {
    // console.log(params)
     const baseURL = options.customBaseURL || DEFAULT_BASE_URL;
    return new Promise((resolve, reject) => {
        axios.post(url, params,{
                baseURL // 覆盖全局的baseURL
            }).then(res => {
                resolve(res.data);
            })
            .catch(err => {
              console.log(err)
                reject(err.data)
            })
    });
}

/** 
 * put方法，对应put请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function put(url, params) {
    // console.log(params)
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/** 
 * delete方法，对应delete请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function delet(url, params) {
    // console.log(params)
    return new Promise((resolve, reject) => {
        axios.delete(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


export { AGENT_BASE_URL };